import { InjectionToken } from '@angular/core';
import { AppInsightsConfig } from '@epicuro-next/models/platform/monitoring';

/**
 * Angular's injection token used to pass the data required to configure App Insights
 */
export const APPINSIGHTS_CONFIG: InjectionToken<AppInsightsConfig> =
  new InjectionToken('APPINSIGHTS_CONFIG');
